define(["require", "exports", "axios"], function (require, exports, axios_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    let $cartAxios = axios_1.default.create();
    $cartAxios.defaults.headers.common['X-Requested-With'] = "XMLHttpRequest";
    function fetchData(req) {
        return req.catch(err => {
            console.log(err);
        });
    }
    class CartAPI {
        getCartControl(data) {
            return fetchData($cartAxios.post(`/cart/configurationcartcontrol`, { data: JSON.stringify(data) }).then(response => response.data));
        }
        getShowcasePricingSummary(data) {
            return fetchData($cartAxios.post(`/cart/showcasepricesummary`, { addToCart: data }).then(response => response.data));
        }
        getOrderCutOffForUser() {
            return fetchData($cartAxios.get('/cart/getordercutoffforuser').then(response => response.data));
        }
        getCart() {
            return fetchData($cartAxios.get("/cart/getcart").then(response => { var _a; return (_a = response.data) === null || _a === void 0 ? void 0 : _a.jsonCart; }));
        }
        getSavedCartItemPage(data) {
            return fetchData($cartAxios.get("/cart/getSavedCartItemPage", { params: data }).then(response => response.data));
        }
        getSavedCartHasNextPage(data) {
            return fetchData($cartAxios.get("/cart/getSavedCartHasNextPage", { params: data }).then(response => response.data));
        }
        getCartCount() {
            return fetchData($cartAxios.get("/cart/getcartcount").then(response => response.data));
        }
        updateCartItem(payload) {
            return fetchData($cartAxios.post("/cart/UpdateCartItemAjax", payload).then(response => response.data));
        }
    }
    exports.default = new CartAPI();
});
//# sourceMappingURL=cart.js.map